// removed by extract-text-webpack-plugin
module.exports = {"cover":"oY2OpvepWX32TuXwIUC7R","media":"_1OKSnYp04HRtAxdx8W2dFQ","visible":"yEIm7g04-2EPy2IaVWiQl","VideoAppear":"uiXxqUrFWDKp3-l8nhB5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/Media.module.scss
// module id = 788
// module chunks = 0